// @flow
import React, { useMemo } from 'react';
import moment from 'moment-timezone';
import classNames from 'classnames';

import Link from 'app/common/lib/link';
import { replaceLastSlash } from 'app/common/lib/path';
import config from 'app/config';

import styles from './DateSwitcher.module.scss';;


type Props = {
  current: string | Date,
  baseUrl: string,
  nextUrl?: string,
  format?: string,
  isDateEnabled?: (date: typeof moment) => boolean,
  month?: boolean,
  className?: string,
}

const DateSwitcher = ({
  current,
  baseUrl,
  nextUrl,
  format = 'DD.MM.YYYY',
  isDateEnabled,
  month,
  className,
}: Props) => {
  const dateFormat = month ? 'YYYY-MM' : config.dateFormat;
  const period = month ? 'month' : 'days';
  const mCurrent = useMemo(() => moment(current, config.dateFormat), [current]);
  const next = useMemo(() => mCurrent.clone().add(1, period), [mCurrent, period]);
  const prev = useMemo(() => mCurrent.clone().subtract(1, period), [mCurrent, period]);
  const basePath = replaceLastSlash(baseUrl);
  return (
    <div className={classNames(styles.root, className)}>
      {(isDateEnabled ? isDateEnabled(prev) : true)
        ? <Link to={`${basePath}/${prev.format(dateFormat)}${nextUrl || ''}`}>&#10094;</Link>
        : <span className={styles.nonlinked}>&#10094;</span>}
      {moment(current, config.dateFormat).format(format)}
      {(isDateEnabled ? isDateEnabled(next) : true)
        ? <Link to={`${basePath}/${next.format(dateFormat)}${nextUrl || ''}`}>&#10095;</Link>
        : <span className={styles.nonlinked}>&#10095;</span>}
    </div>
  );
};

export default DateSwitcher;
